




































import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";
import Request from "@/models/checkRequest/request";
// @ts-ignore
import { Edit2Icon } from "vue-feather-icons";

@Component({
  components: {
    Edit2Icon,
  },
})
export default class EditableUrl extends Vue {
  showUrlEditForm = false;
  hasBeenDiscarded = false;
  localUrl = "";

  @Ref("urlEditInput")
  urlEditInput!: HTMLInputElement;

  @Prop() request!: Request;

  edit() {
    if (this.request) {
      this.localUrl = this.request.url;
      this.showUrlEditForm = true;
      this.hasBeenDiscarded = false;
      this.$nextTick(() => {
        this.urlEditInput.focus();
      });
    }
  }

  discardUrlEdit() {
    //
    // Close edit form
    this.showUrlEditForm = false;
    this.hasBeenDiscarded = true;
  }

  saveUrl() {
    if (this.request) {
      if (this.hasBeenDiscarded) return;
      //
      // Close the form
      this.showUrlEditForm = false;
      //
      // If the name wasn't changed, don't update
      if (this.localUrl !== this.request.url && this.localUrl !== "") {
        this.request.url = this.localUrl;
        this.$emit("edit", this.request);
      }
    }
  }
}
